<template>
    <div class="form form-section-bg">

        <section v-for="addreesee in addreeseeList" class="form-section form-wrap">
            <div class="title">Контактное лицо №{{addreeseeList.indexOf(addreesee) + 1}}</div>
            <div class="form-field-input-2">
                <label>Фамилия</label>
                <div class="field-input-wrapper">
                    <input v-model="addreesee.surname" type="text" disabled>
                </div>
            </div>
            <div class="form-field-input-2">
                <label>Имя и Отчество</label>
                <div class="field-input-wrapper">
                    <input :value="nameAndPatronymic(addreesee)" type="text" disabled>
                </div>
            </div>
            <div class="form-field-input-2">
                <label>Email</label>
                <div class="field-input-wrapper">
                    <input v-model="addreesee.email" type="email" disabled>
                </div>
            </div>
            <div class="form-field-input-2 disabled">
                <label>Номер телефона</label>
                <div class="field-input-wrapper">
                    <vue-tel-input v-model="addreesee.phone"
                                   :inputId="'' + addreeseeList.indexOf(addreesee)"
                                   name="phone"
                                   @country-changed="countryChanged($event, addreeseeList.indexOf(addreesee))"
                                   @validate="phoneValidate($event, addreeseeList.indexOf(addreesee))"
                                   :disabled="true"
                                   :ref="'phoneNumber' + addreeseeList.indexOf(addreesee)"
                    ></vue-tel-input>
                </div>
            </div>
            <div v-for="link in addreesee.linkList" class="form-field-input-2">
                <label> Дополнительный канал связи</label>
                <div class="field-input-wrapper">
                    <input v-model="link.data" type="text" disabled>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
export default {
    name: "ClientContacts",
    props: ['addreeseeList'],
    data() {
        return {
            intlTelNumber: {},
            intlTelCountry: {},
            defaultCountry: 'RU'
        }
    },
    methods: {
        nameAndPatronymic(addreesee) {
            return addreesee.name + ' ' + addreesee.patronymic;
        },
        countryChanged(event, contactIndex) {
            this.addreeseeList[contactIndex].intlTelCountry = event;
            this.addreeseeList[contactIndex].defaultCountry = event.iso2;
            this.$refs['phoneNumber' + contactIndex][0].choose(this.addreeseeList[contactIndex].defaultCountry);

            if (this.addreeseeList[contactIndex].phone && this.addreeseeList[contactIndex].phone.includes("+")) {
                this.addreeseeList[contactIndex].phone = this.addreeseeList[contactIndex].phone.replace("+".concat(event.dialCode), "");
            }
        },
        phoneValidate(event, contactIndex) {
            this.addreeseeList[contactIndex].intlTelNumber = {number: event.number, isValid: event.isValid};
            if (event.isValid) {
                this.addreeseeList[contactIndex].defaultCountry = event.regionCode;
                this.$refs['phoneNumber' + contactIndex][0].choose(event.regionCode);
            }

            if (event.number.international) {
                let index = event.number.international.indexOf(" ");
                this.addreeseeList[contactIndex].phone = event.number.international.slice(index + 1);
            }
        },
    },
}
</script>

<style>
</style>